import { render, staticRenderFns } from "./VDialogIndeferirReserva.vue?vue&type=template&id=052fa4fe"
import script from "./VDialogIndeferirReserva.vue?vue&type=script&lang=js"
export * from "./VDialogIndeferirReserva.vue?vue&type=script&lang=js"
import style0 from "./VDialogIndeferirReserva.vue?vue&type=style&index=0&id=052fa4fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports